export { DatePicker } from './datepicker.component';
export { AngularDateTimePickerModule } from './datepicker.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-datetimepicker/index.js
// module id = ./node_modules/angular2-datetimepicker/index.js
// module chunks = vendor